var E = Object.defineProperty;
var h = (e, t, r) => t in e ? E(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var a = (e, t, r) => (h(e, typeof t != "symbol" ? t + "" : t, r), r);
const m = [
  // Native ES errors https://262.ecma-international.org/12.0/#sec-well-known-intrinsic-objects
  EvalError,
  RangeError,
  ReferenceError,
  SyntaxError,
  TypeError,
  URIError,
  // Built-in errors
  globalThis.DOMException,
  // Node-specific errors
  // https://nodejs.org/api/errors.html
  globalThis.AssertionError,
  globalThis.SystemError
].filter(Boolean).map(
  (e) => [e.name, e]
), g = new Map(m), S = [
  {
    property: "name",
    enumerable: !1
  },
  {
    property: "message",
    enumerable: !1
  },
  {
    property: "stack",
    enumerable: !1
  },
  {
    property: "code",
    enumerable: !0
  },
  {
    property: "cause",
    enumerable: !1
  }
], u = Symbol(".toJSON was called"), O = (e) => {
  e[u] = !0;
  const t = e.toJSON();
  return delete e[u], t;
}, j = (e) => g.get(e) ?? Error, d = ({
  from: e,
  seen: t,
  to: r,
  forceEnumerable: s,
  maxDepth: i,
  depth: c,
  useToJSON: l,
  serialize: f
}) => {
  if (!r)
    if (Array.isArray(e))
      r = [];
    else if (!f && b(e)) {
      const n = j(e.name);
      r = new n();
    } else
      r = {};
  if (t.push(e), c >= i)
    return r;
  if (l && typeof e.toJSON == "function" && e[u] !== !0)
    return O(e);
  const y = (n) => d({
    from: n,
    seen: [...t],
    forceEnumerable: s,
    maxDepth: i,
    depth: c,
    useToJSON: l,
    serialize: f
  });
  for (const [n, o] of Object.entries(e)) {
    if (typeof Buffer == "function" && Buffer.isBuffer(o)) {
      r[n] = "[object Buffer]";
      continue;
    }
    if (o !== null && typeof o == "object" && typeof o.pipe == "function") {
      r[n] = "[object Stream]";
      continue;
    }
    if (typeof o != "function") {
      if (!o || typeof o != "object") {
        r[n] = o;
        continue;
      }
      if (!t.includes(e[n])) {
        c++, r[n] = y(e[n]);
        continue;
      }
      r[n] = "[Circular]";
    }
  }
  for (const { property: n, enumerable: o } of S)
    typeof e[n] < "u" && e[n] !== null && Object.defineProperty(r, n, {
      value: b(e[n]) ? y(e[n]) : e[n],
      enumerable: s ? !0 : o,
      configurable: !0,
      writable: !0
    });
  return r;
};
function C(e, t = {}) {
  const {
    maxDepth: r = Number.POSITIVE_INFINITY,
    useToJSON: s = !0
  } = t;
  return typeof e == "object" && e !== null ? d({
    from: e,
    seen: [],
    forceEnumerable: !0,
    maxDepth: r,
    depth: 0,
    useToJSON: s,
    serialize: !0
  }) : typeof e == "function" ? `[Function: ${e.name ?? "anonymous"}]` : e;
}
function b(e) {
  return !!e && typeof e == "object" && "name" in e && "message" in e && "stack" in e;
}
class p extends Error {
  /**
   * @param message Error message, as displayed in the logs
   * @param data Custom metadata added in the logs
   */
  constructor(r, s) {
    super(r);
    a(this, "data");
    a(this, "cause");
    this.data = s, this.name = "Oops";
  }
  /**
   * Add a cause to the current error
   * @param cause Original error
   */
  wrap(r) {
    return this.cause = r, this;
  }
  toString() {
    const { name: r, message: s, cause: i } = this;
    return !s && i !== void 0 ? `${r}: ${String(i)}` : `${r}: ${s}`;
  }
  /**
   * Returns a serializable representation of an object.
   */
  toJSON() {
    return {
      name: this.name,
      stack: this.stack,
      message: this.message,
      data: this.data,
      cause: C(this.cause)
    };
  }
}
a(p, "description");
class T extends p {
  /**
   * @param _switchCase The variable whose type should never occured
   * @param message Error message, as displayed in the logs
   * @param data Custom metadata added in the logs
   */
  constructor(t, r, s) {
    super(r, s);
  }
}
class k extends p {
  /**
   * @deprecated
   * @param statusCode HTTP Status code that will be returned as part of the response
   * @param message Error message
   * @param data Custom metadata
   */
  constructor(r, s, i) {
    super(s, i);
    a(this, "statusCode");
    this.statusCode = r;
  }
}
export {
  p as Oops,
  k as OopsHttp,
  T as TypeGuardError
};
